export default __webpack_public_path__ + "static/media/home-magazine-img-05.493729a7.jpg";